module.exports = __webpack_public_path__ + "static/1_1_defineai_SK-cc9d6a2b9933e2bae844e47f97b81aac.svg";